
import MessageBox from '@nextrequestco/components/src/components/MessageBox/MessageBox.vue'
import NrEditor from '@nextrequestco/components/src/components/NrEditor/nr-editor.vue'
import NrFormLabel from '@nextrequestco/components/src/components/form-elements/nr-form-label.vue'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput/nr-form-input.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'NoteMessageModal',
  components: { MessageBox, 'nr-editor': NrEditor, NrFormLabel, NrFormInput },

  data() {
    return {
      message: '',
      pin: false
    }
  },
  computed: {
    ...mapState({
      hasPinningNotesEnabled: (state) =>
        // @ts-ignore: NEX-9140
        !!(state.account && state.account.pinning_notes_feature_flag)
    }),

    ...mapState('request_show', ['displayMsgBox', 'currentAction', 'request']),

    shouldShowPinOption(): boolean {
      return (
        this.hasPinningNotesEnabled && this.$can('create', 'RequestEventPin')
      )
    },

    displayNoteMsgBox(): boolean {
      return this.displayMsgBox && this.currentAction === 'edit'
    }
  },

  methods: {
    ...mapActions('request_show', [
      'setDisplayMsgBox',
      'submitInternalMessage'
    ]),

    handleCancelMessage(): void {
      this.message = ''
      this.pin = false
      this.setDisplayMsgBox(false)
    },

    handleSubmitMessage(): void {
      this.submitInternalMessage({
        note_text: this.message,
        request_id: this.request.pretty_id,
        state: 'staff',
        note_type: 'request-note',
        note_pinned: this.pin
      }).then(() => {
        this.handleCancelMessage()
      })
    },

    async changedPin(event) {
      this.pin = event.target.checked
    }
  }
}
